// import get from 'lodash/get';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Card from '../card/card';
import FCLink from '../fc_link/fc_link';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';
// eslint-disable-next-line react/prefer-stateless-function
export default class Recirc extends Component {
  // TODO: @mbenin @jferrie Revisit this logic
  /*
  shouldComponentUpdate(nextProps) {
    return (
      get(this.props, 'recircFeed.hide') !== get(nextProps, 'recircFeed.hide')
    );
  } */

  render() {
    const { config, feed } = this.props;
    const properties = [
      {
        key: 'ideas',
        title: 'Impact',
        data: get(feed, 'ideas', []),
        link: 'https://www.fastcompany.com/ideas'
      },
      {
        key: 'entertainment',
        title: 'Creativity',
        data: get(feed, 'entertainment', []),
        link: 'https://www.fastcompany.com/entertainment'
      },
      {
        key: 'design',
        title: 'Co.Design',
        data: get(feed, 'design', []),
        link: 'https://www.fastcompany.com/co-design'
      },
      {
        key: 'leadership',
        title: 'Work Life',
        data: get(feed, 'leadership', []),
        link: 'https://www.fastcompany.com/leadership'
      }
    ];

    return (
      <div className="recirc">
        {properties.map(property => (
          <div key={property.key} className="recirc__column">
            <h3 className={`recirc__title recirc__title--${property.key}`}>
              <FCLink config={config} to={property.link}>
                {property.title}
              </FCLink>
            </h3>
            {property.data.map((story, idx) => (
              <Card
                type="recirc"
                config={config}
                metadata={story}
                key={story.id}
                cardEvent={() => {
                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: `RecirculationModule:Pos-${idx + 1}`,
                    eventLabel: `${property.title}:${get(story, 'link')}`
                  });
                }}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }
}

Recirc.propTypes = {
  config: PropTypes.shape({}).isRequired,
  feed: PropTypes.shape({}).isRequired
};
